export default "__VITE_ASSET__ce16e959__"